import $ from 'jquery';
window.$ = $;
window.jQuery = $;

const $document = $(document);
const $body = $('body');

const localStorageKey = 'isFlyoutActive';

$body.addClass('flyout-enabled');

$('.js-flyout-toggle').each(function () {

    const $this = $(this);
    const $flyoutRegion = $($this.attr('href'));

    $this.on('click', function (e) {

        e.preventDefault();

        $body.toggleClass('flyout-active');
        localStorage.setItem(localStorageKey, $body.hasClass('flyout-active'));
    });

    $document.on('click', '.flyout__close, .flyout__overlay, .js-flyout-close', function (e) {

        e.preventDefault();

        $body.removeClass('flyout-active');
        localStorage.setItem(localStorageKey, false);
    });

    //  Multi-level flyout menu
    $flyoutRegion.find('a + ul').each(function () {

        const $submenu = $(this);
        const $anchor = $submenu.prev();
        const $backItem = $('<li><a href="#" class="flyout__back">Back</a></li>');

        $(this).prepend($backItem);

        $anchor.on('click', function (e) {
            e.preventDefault();
            $(this).parent().addClass('is-active');
        });

        $backItem.find('.flyout__back').on('click', function (e) {
            e.preventDefault();
            $(this).closest('li.is-active').removeClass('is-active');
        });
    });
});
